var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_5905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23.9153C27.4998 24.3839 27.4073 24.848 27.2277 25.2809C27.0482 25.7138 26.7851 26.1071 26.4536 26.4383C26.122 26.7696 25.7285 27.0322 25.2954 27.2114C24.8623 27.3905 24.3982 27.4826 23.9295 27.4823H6.071C5.12448 27.4827 4.21656 27.1071 3.54689 26.4382C2.87723 25.7693 2.50066 24.8618 2.5 23.9153V6.08312C2.50079 5.13673 2.87743 4.22941 3.5471 3.56067C4.21676 2.89194 5.12461 2.51656 6.071 2.51709H23.9295C24.3981 2.51676 24.8622 2.60875 25.2952 2.78779C25.7283 2.96683 26.1218 3.22942 26.4534 3.56056C26.7849 3.8917 27.048 4.28491 27.2276 4.71774C27.4072 5.15056 27.4997 5.61452 27.5 6.08312V23.9153Z",
    fill: "#FFE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 17.4968C20.2495 16.6266 19.8144 15.8303 19.1427 15.2659C19.0433 15.1784 18.9354 15.0969 18.8161 15C18.9155 14.9254 18.9981 14.8683 19.0751 14.8041C19.5586 14.404 19.932 13.8871 20.1602 13.3025C20.3763 12.7496 20.4449 12.15 20.3591 11.5627C20.264 10.8482 19.9482 10.1813 19.4559 9.65491C19.105 9.26417 18.6715 8.95649 18.1868 8.75421C17.7161 8.56364 17.2123 8.46818 16.7045 8.47336H11.014C10.9748 8.47112 10.9354 8.47112 10.8962 8.47336C10.8338 8.4762 10.775 8.50341 10.7324 8.54914C10.6898 8.59487 10.6669 8.65547 10.6685 8.71792C10.6685 8.75769 10.6685 8.79696 10.6685 8.83623V21.1314C10.6685 21.1931 10.6651 21.2552 10.6685 21.3168C10.6711 21.3678 10.6914 21.4162 10.7258 21.4538C10.7603 21.4914 10.8069 21.5157 10.8574 21.5226C10.8965 21.5274 10.9359 21.5289 10.9752 21.5271H16.8686C17.4621 21.5294 18.0455 21.3735 18.5586 21.0753C19.2918 20.6633 19.8577 20.0077 20.1582 19.2222C20.3752 18.6746 20.4453 18.0798 20.3615 17.4968ZM15.8327 17.9392H14.7694V12.0737H15.8207C15.8207 12.0737 15.8168 12.0707 15.8207 12.0707V12.0737H15.8327V17.9392Z",
    fill: "#1E1719"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_5905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24.9657,
    fill: "white",
    transform: "translate(2.5 2.51709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/카카오뱅크-30.9e91918104ebebcd1c3042955e70cf72.svg";
export { ForwardRef as ReactComponent };